<template>
    <div>
        <simpleHeaderBar name="问题反馈"></simpleHeaderBar>
        <div class="survey">
            <div class="survey-header">
                感谢您对万家医疗的支持，<span>请在此说明您要反馈的内容，后续我们将安排专人处理您的反馈。</span>
            </div>
            <div class="survey-input">
                <Form ref="formValidate" :rules="ruleValidate" label-position="top" class="survey-box" :model="formValidate"
                      :label-width="100">
                    <FormItem label="反馈类型：" prop="feedbackType" class="question-type">
                        <RadioGroup v-model="formValidate.feedbackType">
                            <Radio class="radio" label="0">新功能需求</Radio>
                            <Radio class="radio" label="1">一般咨询</Radio>
                            <Radio class="radio" label="2">系统问题</Radio>
                            <Radio class="radio" label="3">投诉建议</Radio>
                        </RadioGroup>
                    </FormItem>
                    <FormItem label="反馈主题：" prop="title">
                        <Input v-model="formValidate.title" placeholder="请输入反馈主题(50字以内)"
                               :maxlength="maxLength50"></Input>
                    </FormItem>
                    <FormItem label="反馈内容：" prop="feedbackContent" class="feed-content">
                        <Input class="textarea" v-model="formValidate.feedbackContent" type="textarea"
                               :autosize="{minRows: 5,maxRows: 10}"
                               :placeholder="feedPlaceHolder"
                               :autofocus="autoFocus"
                               @on-change="watchWords"
                               :maxlength="maxLength500"></Input>
                        <div class="leftWordsCountTips" style="text-align: right">
                            还可以输入
                            <span v-if="leftWordsCount==0" style="color: #ff400a">{{leftWordsCount}}</span>
                            <span v-else>{{leftWordsCount}}</span>
                            字
                        </div>
                    </FormItem>
                    <FormItem class="img-upload" label="上传图片" prop="uploadList">
                        <span class="tips">（非必填项，可上传5张，上传图片格式为JPG，PNG格式，每张大小2M以内）：</span>
                        <div class="demo-upload-list" v-for="item in formValidate.uploadList">
                            <template v-if="item.status === 'finished'">
                                <img :src="item.url">
                                <div class="demo-upload-list-cover">
                                    <Icon type="ios-close" @click.native="handleRemove(item)"></Icon>
                                </div>
                            </template>
                            <template v-else>
                                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
                            </template>
                        </div>
                        <Upload
                                v-show="isUploadBtnShow"
                                ref="upload"
                                :show-upload-list="false"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :format="['jpg','jpeg','png']"
                                :max-size="2048"
                                :on-format-error="handleFormatError"
                                :on-exceeded-size="handleMaxSize"
                                :before-upload="handleBeforeUpload"
                                type="drag"
                                :action="imgUpload"
                                style="display: inline-block;width:145px;">
                            <div style="width: 145px;height:110px;line-height: 130px;">
                                <Icon type="camera" size="50"></Icon>
                            </div>
                        </Upload>
                    </FormItem>
                    <FormItem label="相关医疗机构名称" class="hospital-title" prop="hospitalTitle">
                        <span class="tips">（若有请填写）：</span>
                        <Input v-model="formValidate.hospitalTitle" placeholder="请输入相关医疗机构名称"
                               :maxlength="maxLength50"></Input>
                    </FormItem>
                    <FormItem class="short-label" label="联系人姓名："  prop="contactName">
                        <Input v-model="formValidate.contactName" placeholder="请输入联系人姓名"
                               :maxlength="maxLength20"></Input>
                    </FormItem>
                    <FormItem class="short-label" label="联系电话：" :maxlength="maxLength12" prop="contactPhone">
                        <Input v-model="formValidate.contactPhone" placeholder="请输入您的手机号或固定电话号码(例：021-xxxxxxxx)"></Input>
                    </FormItem>
                    <p>
                        感谢您的反馈，我们会尽快处理，谢谢！
                    </p>
                    <div class="btn">
                        <Button type="primary" class="btn-submit" :loading="loading"
                                @click="handleSubmit('formValidate')">
                            <span v-if="!loading">提交</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
        <simpleFooterBar></simpleFooterBar>
        <Modal class="dialog-msg"
               v-model="visible"
               :mask-closable="false"
               :scrollable="true"
               :closable="false"
               @on-ok="handleReset('formValidate')"
        >
            <p>
                已收到您的反馈<br>
                稍后会有工作人员跟你联系~！
            </p>
        </Modal>
    </div>
</template>
<script>
    import simpleHeaderBar from './../Common/simpleHeaderBar';
    import simpleFooterBar from './../Common/simpleFooterBar';
    import url from './../../../config/url';
    import axios from 'axios';

    export default {
        components: {
            simpleHeaderBar: simpleHeaderBar,
            simpleFooterBar: simpleFooterBar
        },

        data() {
            return {
                feedPlaceHolder:"请尽可能详细描述您的需求／问题，建议按下面模版填写\n遇到的问题：\n希望的效果：\n其他的要求：",
                isShowTips: true,
                leftWordsCount:500,
                maxLength20: 20,
                maxLength12: 12,
                maxLength50: 50,
                maxLength500: 500,
                loading: false,
                isUploadBtnShow: true,
                imgUpload: url.saveFeedbackPicture,
                autoFocus: false,
                visible: false,
                imgList:[],
                formValidate: {
                    title: '',
                    feedbackContent: '',
                    hospitalTitle: "",
                    feedbackType: '',
                    uploadList: [],
                    contactName: "",
                    contactPhone: ""
                },
                ruleValidate: {
                    feedbackType: [
                        { required: true, message: '请选择反馈类型！', trigger: 'change'},
                    ],
                    title: [
                        { required: true, message: '反馈主题不能为空！', trigger: 'blur'},
                    ],
                    contactName: [
                        {required: true, message: '联系人姓名不能为空！', trigger: 'blur'},
                        {type: 'string', trigger: 'blur'}
                    ],
                    contactPhone: [
                        {required: true, message: '联系电话不能为空！', trigger: 'blur'},
                        {
                            validator(rule, value, callback) {
                                var errors = [];
                                if (!((value.match(/^(13|15|17|18|14)[0-9]{9}$/)) || (value.match(/^0\d{2,3}-\d{7,8}$/)))) {
                                    callback('联系电话格式不正确');
                                }
                                callback(errors);
                            }, trigger: 'blur'
                        }
                    ],
                    feedbackContent: [
                        {required: true, message: '反馈内容不能为空！', trigger: 'blur'}
                    ],
                }
            }
        },
        created: function () {
            this.getUserMobile();
        },
        mounted: function () {
            this.formValidate.uploadList = this.$refs.upload.fileList;
        },
        methods: {
            watchWords(){
                var len = this.formValidate.feedbackContent.length;
                this.leftWordsCount  = 500 - len;
            },
            getUserMobile(){
                var _this = this;
                axios.get(url.getUserMobile)
                    .then(function (response) {
                    var res = response.data;
                    if(res.status == "SUCCESS" && res.result != null){
                        _this.formValidate.contactPhone = res.result;
                    }
                }).catch(function () {
                    _this.$Message.error('数据获取失败,请稍后再试!');
                });
            },
            handleReset(){
                window.location.href = window.location.href;
            },
            handleSubmit(name) {
                var _this = this;
                _this.$refs[name].validate((valid) => {
                    if (valid) {
                        _this.loading = true;
                        var feedbackSource = _this.$route.query.feedbackSource;
                        var params = {
                            userId: url.userId
                        };
                        var clinicFeedBackImages = [];
                        _this.formValidate.uploadList.forEach(function (item, index) {
                            clinicFeedBackImages.push({
                                "imageId": item.response.result.imageId,
                                "imageTypeCode": "OPERATION_FEEDBACK",
                                "imageOrder": index + 1,
                                "imageSource": feedbackSource,
                            })
                        });
                        var feedbackInfo = {
                            clinicFeedBack: {
                                "feedbackTheme": _this.formValidate.title.trim(),
                                "feedbackType": _this.formValidate.feedbackType,
                                "contactName": _this.formValidate.contactName.trim(),
                                "contactPhone": _this.formValidate.contactPhone.trim(),
                                "feedbackContent": _this.formValidate.feedbackContent.trim(),
                                "feedbackSource": feedbackSource,
                                "userClinicName": _this.formValidate.hospitalTitle.trim(),
                            },
                            clinicFeedBackImages: clinicFeedBackImages
                        };
                        params.feedbackInfo = JSON.stringify(feedbackInfo);
                        axios({
                            url: url.saveFeedbackInfo,
                            method:"post",
                            data: params,
                            transformRequest: [function (data) {
                                let ret = [];
                                for (let it in data) {
                                    ret.push(encodeURIComponent(it) + '=' + encodeURIComponent(data[it]))
                                }
                                return ret.join("&");
                            }],
                        }).then(function (response) {
                            var res = response.data;
                            _this.loading = false;
                            if(res.status == "SUCCESS"){
                                _this.visible = true;
                            }else{
                                _this.$Message.error(res.errorMsg);
                            }
                        }).catch(function () {
                            _this.loading = true;
                            _this.$Message.error('数据提交失败，请稍后再试！');
                        });
                    }
                })
            },
            handleRemove (file) {
                const fileList = this.$refs.upload.fileList;
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
                if (this.formValidate.uploadList.length < 5) {
                    this.isUploadBtnShow = true;
                } else {
                    this.isUploadBtnShow = false;
                }
            },
            handleSuccess (res, file) {
                if(file.response.status == "SUCCESS"){
                    file.url = file.response.result.imageUrl;
                    file.name = file.response.result.imageId;
                    if (this.formValidate.uploadList.length < 5) {
                        this.isUploadBtnShow = true;
                    } else {
                        this.isUploadBtnShow = false;
                    }
                }else{
                    this.$Message.error('图片上传失败，请稍后再试');
                }
            },
            handleError() {
                if (this.formValidate.uploadList.length < 5) {
                    this.isUploadBtnShow = true;
                } else {
                    this.isUploadBtnShow = false;
                }
                this.$Message.error('图片上传失败，请稍后再试');
            },
            handleFormatError(file) {
                this.$Message.error('请上传jpg,jpeg,png格式图片');
            },
            handleMaxSize(file) {
                this.$Message.error('图片必须小于2M');
            },
            handleBeforeUpload() {
                const check = this.formValidate.uploadList.length < 5;
                if (!check) {
                    this.$Message.error('最多只能上传5张图片');
                }
                if (this.formValidate.uploadList.length < 4) {
                    this.isUploadBtnShow = true;
                } else {
                    this.isUploadBtnShow = false;
                }
                return check;
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../../static/scss/page/survey";
</style>
<style lang="scss">
    .survey-box {
        .ivu-radio-wrapper,.ivu-input{
            font-size: 14px !important;
        }
        .ivu-radio-inner:after{
            background-color: #3d8ff5;
        }
        .ivu-radio-checked .ivu-radio-inner, .ivu-radio-checked:hover .ivu-radio-inner {
            border-color: #d7dde4;
        }
        .textarea textarea {
            resize: none;
            overflow: hidden !important;
        }
        .ivu-form-item {
            margin-bottom: 20px;
        }
        .ivu-form-item-label {
            padding: 10px 12px 10px 0 !important;;
            font-size: 14px !important;;
            text-align: left !important;;
        }
        .question-type {
            margin-left: 0 !important;
            .ivu-form-item-label {
                float: left;
            }
        }
        .ivu-form-item-content {
            margin-left: 0px !important;
            width: 792px;
            .ivu-input {
                border-radius: 0 !important;
            }
        }
        .img-upload {
            .ivu-form-item-content{
                height: 118px !important;
            }
            .tips {
                position: absolute;
                font-size: 12px;
                color: #999;
                left: 59px;
                top: -33px;
            }
            .demo-upload-list {
                vertical-align: top;
                overflow: inherit;
            }
            .demo-upload-list-cover {
                background: none !important;
                i {
                    position: absolute;
                    top: -10px;
                    right: -10px;
                    width: 21px;
                    height: 21px;
                    background: url("../../../static/img/img-close-btn.png") no-repeat;
                    &:before {
                        content: "" !important;
                    }
                }
            }
        }
        .ivu-icon-camera:before {
            content: "" !important;
            display: block;
            width: 68px;
            height: 68px;
            margin-top: 20px;
            background: url("../../../static/img/uploadIcon.png") no-repeat;
        }
        .ivu-upload-drag {
            border-radius: 0;
        }
        .hospital-title {
            position: relative;
            .ivu-form-item-label {
                width: 140px !important;
            }
            .tips {
                position: absolute;
                font-size: 12px;
                color: #999;
                left: 115px;
                top: -33px;
            }
        }
        .short-label {
            .ivu-form-item-label {
                width: 140px !important;
            }
            .ivu-input {
                width: 300px !important;
            }
        }
        .ivu-form-item-error-tip {
            padding-left: 15px;
            &:before {
                content: "";
                display: inline-block;
                background: url("../../../static/img/error_icon.png") no-repeat;
                width: 13px;
                height: 13px;
                position: absolute;
                top: 5px;
                left: 0;
            }
        }
        .ivu-progress-bg{
            height: 6px !important;
        }
        .ivu-progress-inner{
            width: 60%;
            margin-top: 30px !important;
        }
    }
    .demo-upload-list {
        display: inline-block;
        width: 140px;
        height: 112px;
        text-align: center;
        line-height: 110px;
        border: 1px solid transparent;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 15px;

    }

    .demo-upload-list img {
        width: 100%;
        height: 100%;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .demo-upload-list:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    .dialog-msg {
        .ivu-modal {
            width: 328px !important;
            height: 175px !important;
            top: 50%;
            position: fixed !important;
            left: 50%;
            margin-left: -164px !important;
            margin-top: -110px !important;
        }
        .ivu-modal-content {
            border-radius: 0;
            border: 1px solid #ccc;
        }
        .ivu-modal-close {
            right: 5px;
            top: -4px;
        }
        .ivu-modal-body {
            text-align: center;
            padding: 30px 0 20px;
            font-size: 16px;
        }
        .ivu-btn-text {
            display: none;
        }
        .ivu-modal-footer {
            padding: 12px 18px 25px 18px !important;
            text-align: center !important;
            border: none;
        }
        .ivu-btn-primary {
            width: 105px !important;
            height: 32px !important;
            margin: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Survey/index.vue